import {Box, Divider, Grid, Typography} from "@mui/material";
import {TextFieldForm} from "@/global/components/FormInputs";
import type {AdditionalInfoKeys, zodCreateTicketType} from "@/modules/tickets";
import type {Control} from "react-hook-form";

interface Props {
    label: string,
    fieldname: AdditionalInfoKeys,
    control: Control<zodCreateTicketType>,
}

export function FieldPair({control, label, fieldname}: Props) {
    const isDate = fieldname.includes('date');

    return (
        <Box mb={3}>
            <Typography
                variant="subtitle2"
                fontWeight={600}
                mb={1}
            >
                {label}
            </Typography>
            <Grid
                container
                spacing={2}
            >
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <TextFieldForm
                        control={control}
                        name={`additional_info.${fieldname}.old`}
                        placeholder="Некорректное значение"
                        type={isDate ? 'date' : 'text'}
                        fullWidth
                        size="small"
                        label="Некорректное значение"
                        sx={{
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#f44336',
                                },
                                '& fieldset': {
                                    borderColor: '#e57373',
                                }
                            }
                        }}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                >
                    <TextFieldForm
                        control={control}
                        name={`additional_info.${fieldname}.new`}
                        placeholder="Новое корректное значение"
                        fullWidth
                        size="small"
                        type={isDate ? 'date' : 'text'}
                        label="Новое значение"
                        sx={{
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#4caf50',
                                },
                                '& fieldset': {
                                    borderColor: '#81c784',
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>
            <Divider sx={{mt: 2}}/>
        </Box>
    );
};